import { render } from "./DiscountInfo.vue?vue&type=template&id=2e7a61dc"
import script from "./DiscountInfo.vue?vue&type=script&lang=js"
export * from "./DiscountInfo.vue?vue&type=script&lang=js"

import "./DiscountInfo.vue?vue&type=style&index=0&id=2e7a61dc&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__